import React from "react";

const EMAIL = /^[\w.+-]+@[\w.-]+\.\w{2,}$/;
const PHONE = /^\+?\d[\d\s()-]{6,}$/;

interface Props {
  line: string;
  className?: string;
  as?: "p" | "span" | "div";
}

export default function AutoContactLine({ line, className, as = "p" }: Props) {
  const Tag = as as "p";
  const trimmed = line.trim();

  if (EMAIL.test(trimmed)) {
    return (
      <Tag className={className}>
        <a
          href={`mailto:${trimmed}`}
          className="hover:underline underline-offset-4 break-all"
        >
          {line}
        </a>
      </Tag>
    );
  }

  if (PHONE.test(trimmed)) {
    return (
      <Tag className={className}>
        <a
          href={`tel:${trimmed.replace(/[\s()-]/g, "")}`}
          className="hover:underline underline-offset-4 whitespace-nowrap"
        >
          {line}
        </a>
      </Tag>
    );
  }

  return <Tag className={className}>{line}</Tag>;
}
